// extracted by mini-css-extract-plugin
export default {"danger-modal":"dangerModal_danger-modal__mOSau","danger-modal__icon":"dangerModal_danger-modal__icon__BfgpG"};